import { Component } from '@angular/core';

@Component({
  selector: 'app-problem-section',
  standalone: true,
  templateUrl: './problem-section.component.html',
  styleUrl: './problem-section.component.scss'
})
export class ProblemSectionComponent {}

